import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const CheckPlusIcon = (props: IconProps) => (
  <Icon w="16px" h="16px" viewBox="0 0 16 16" {...props}>
    <path d="M14 3.45398L6.39335 11.0673L3.56669 8.24065L4.50669 7.30065L6.39335 9.18732L13.06 2.52065L14 3.45398ZM7.33335 13.334C4.39335 13.334 2.00002 10.9407 2.00002 8.00065C2.00002 5.06065 4.39335 2.66732 7.33335 2.66732C8.38002 2.66732 9.36002 2.97398 10.1867 3.50065L11.1534 2.53398C10.0667 1.78065 8.75335 1.33398 7.33335 1.33398C3.65335 1.33398 0.666687 4.32065 0.666687 8.00065C0.666687 11.6807 3.65335 14.6673 7.33335 14.6673C8.48669 14.6673 9.57335 14.374 10.52 13.854L9.52002 12.854C8.85335 13.1607 8.11335 13.334 7.33335 13.334ZM12 10.0007H10V11.334H12V13.334H13.3334V11.334H15.3334V10.0007H13.3334V8.00065H12V10.0007Z" />
  </Icon>
);

export default memo(CheckPlusIcon);
